// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen {
  .special {
    color: var(--ion-color-danger) !important;
  }
  .orc {
    font-size: 8px;
  }
  .vehicle-result {
    clear: left;
    height: auto;
    display: block;
  }
  .vehicle-search-image {
    margin-inline-end: 16px;
  }
  app-image-displayer {
    border-radius: 5px;
    width: 56px;
    height: 56px;
    float: left;
  }
  .vehicle-data {
    margin-bottom: 4px;
  }
  .stock-yard {
    font-size: 11px;
    line-height: xrem(11px);
    margin-bottom: 2px;
  }
  .location-status {
    float: right;
    width: 50%;
    max-height: 15px;
  }
  .status-content {
    width: 100%;
  }
  .status-selector-tap-target {
    position: absolute;
    height: 30px;
    z-index: 10;
    display: block;
    right: 0px;
    width: 50px;
    text-align: right;
    top: 0px;
  }
  h6 {
    font-weight: 500;
  }
  .price-container {
    line-height: 1;
    margin-top: 4px;
  }
  .price-container .more i {
    font-size: 24px;
  }
  .opportunities {
    font-size: 12px;
  }
  .price {
    font-size: 12px;
    display: inline-block;
  }
  .price.popup {
    cursor: pointer;
  }
  .company-code {
    float: right;
  }
  .vehicle-name h6 {
    margin-top: 0;
    font-size: 15px;
  }
  .vehicle-specs {
    line-height: 0px;
  }
  .vehicle-specs app-attribute-list {
    line-height: 10px;
    color: var(--ion-color-medium);
    font-size: 10px;
  }
  .status-indicator {
    top: 0;
    margin-right: 4px;
  }
  .inactive-vehicle {
    opacity: 0.5;
  }
}
/* min-width 640px, medium screens */
@media only screen and (min-width: 640px) {
  .vehicle-result {
    margin: auto;
  }
  h6 {
    width: 80%;
  }
}
@media only screen and (max-width: 359px) {
  app-image-displayer {
    width: 50px;
    height: 50px;
  }
}
.status-indicator {
  top: 0;
  margin-right: 4px;
}

.inactive-vehicle {
  opacity: 0.5;
}

.vehicle-status.unsold .status-indicator {
  background-color: #ff0000;
}

.vehicle-status.all .status-indicator {
  background-color: #25aa3b;
}

.vehicle-status.all .status-indicator {
  background-color: var(--ion-color-primary);
}

.vehicle-status.inactive .status-indicator {
  background-color: #ccc;
}

.vehicle-status.sold .status-indicator {
  background-color: #ff66ff;
}

.vehicle-status.onyard .status-indicator {
  background-color: #0c0;
}

.vehicle-status.atsupplier .status-indicator {
  background-color: #f90;
}

.vehicle-status.atcompliance .status-indicator {
  background-color: #999;
}

.vehicle-status.intransit .status-indicator {
  background-color: #fc0;
}

.vehicle-status.ontestdrive .status-indicator {
  background-color: #06f;
}

.vehicle-status.onloan .status-indicator {
  background-color: #06f;
}

.vehicle-status.atorigin .status-indicator {
  background-color: #ee6558;
}

.vehicle-status.atauction .status-indicator {
  background-color: #57bad2;
}

.vehicle-status.other .status-indicator {
  background-color: #909090;
}

.status-indicator.small {
  top: 0;
  margin-right: 4px;
}

ion-icon[name=checkbox-selected],
ion-icon[name=checkbox-unselected],
ion-icon[name=checkbox-indeterminate] {
  font-size: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/bulk-update-vehicle-list-item/bulk-update-vehicle-list-item.component.scss"],"names":[],"mappings":"AAEA;EACI;IACI,yCAAA;EADN;EAIE;IACI,cAAA;EAFN;EAKE;IACI,WAAA;IACA,YAAA;IACA,cAAA;EAHN;EAME;IACI,uBAAA;EAJN;EAQE;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;EANN;EASE;IAII,kBAAA;EAVN;EAaE;IACI,eAAA;IACA,uBAAA;IACA,kBAAA;EAXN;EAcE;IACI,YAAA;IACA,UAAA;IACA,gBAAA;EAZN;EAeE;IACI,WAAA;EAbN;EA0BE;IACI,kBAAA;IACA,YAAA;IACA,WAAA;IACA,cAAA;IACA,UAAA;IACA,WAAA;IACA,iBAAA;IACA,QAAA;EAxBN;EA2BE;IACI,gBAAA;EAzBN;EA4BE;IACI,cAAA;IACA,eAAA;EA1BN;EA6BU;IACI,eAAA;EA3Bd;EAgCE;IACI,eAAA;EA9BN;EAiCE;IACI,eAAA;IACA,qBAAA;EA/BN;EAiCM;IACI,eAAA;EA/BV;EAmCE;IACI,YAAA;EAjCN;EAqCM;IACI,aAAA;IACA,eAAA;EAnCV;EAuCE;IACI,gBAAA;EArCN;EAuCM;IACI,iBAAA;IAEA,8BAAA;IACA,eAAA;EAtCV;EA0CE;IACI,MAAA;IACA,iBAAA;EAxCN;EA2CE;IACI,YAAA;EAzCN;AACF;AA6CA,oCAAA;AACA;EACI;IAEI,YAAA;EA5CN;EA+CE;IACI,UAAA;EA7CN;AACF;AAgDA;EACI;IACI,WAAA;IACA,YAAA;EA9CN;AACF;AAiDA;EACI,MAAA;EACA,iBAAA;AA/CJ;;AAkDA;EACI,YAAA;AA/CJ;;AAoDA;EACI,yBAAA;AAjDJ;;AAoDA;EACI,yBAAA;AAjDJ;;AAoDA;EACI,0CAAA;AAjDJ;;AAoDA;EACI,sBAAA;AAjDJ;;AAoDA;EACI,yBAAA;AAjDJ;;AAoDA;EACI,sBAAA;AAjDJ;;AAoDA;EACI,sBAAA;AAjDJ;;AAoDA;EACI,sBAAA;AAjDJ;;AAoDA;EACI,sBAAA;AAjDJ;;AAoDA;EACI,sBAAA;AAjDJ;;AAoDA;EACI,sBAAA;AAjDJ;;AAoDA;EACI,yBAAA;AAjDJ;;AAoDA;EACI,yBAAA;AAjDJ;;AAoDA;EACI,yBAAA;AAjDJ;;AAoDA;EACI,MAAA;EACA,iBAAA;AAjDJ;;AAoDA;;;EAGI,eAAA;AAjDJ","sourcesContent":["// @import \"./theme/mixins.scss\";\r\n\r\n@media only screen {\r\n    .special {\r\n        color: var(--ion-color-danger) !important;\r\n    }\r\n\r\n    .orc {\r\n        font-size: 8px;\r\n    }\r\n\r\n    .vehicle-result {\r\n        clear: left;\r\n        height: auto;\r\n        display: block;\r\n    }\r\n\r\n    .vehicle-search-image {\r\n        margin-inline-end: 16px;\r\n        // align-self: start;\r\n    }\r\n\r\n    app-image-displayer {\r\n        border-radius: 5px;\r\n        width: 56px;\r\n        height: 56px;\r\n        float: left;\r\n    }\r\n\r\n    .vehicle-data {\r\n        // width: calc(100% - 80px);\r\n        // width: calc(100% - 100px);\r\n        // float: left;\r\n        margin-bottom: 4px;\r\n    }\r\n\r\n    .stock-yard {\r\n        font-size: 11px;\r\n        line-height: xrem(11px);\r\n        margin-bottom: 2px;\r\n    }\r\n\r\n    .location-status {\r\n        float: right;\r\n        width: 50%;\r\n        max-height: 15px;\r\n    }\r\n\r\n    .status-content {\r\n        width: 100%;\r\n    }\r\n\r\n    // .status-caption {\r\n    //   float: right;\r\n    //   width: 65%;\r\n    //   max-width: 65%;\r\n    //   display: block;\r\n    //   white-space: nowrap;\r\n    //   overflow: hidden;\r\n    //   text-overflow: ellipsis;\r\n    // }\r\n\r\n    .status-selector-tap-target {\r\n        position: absolute;\r\n        height: 30px;\r\n        z-index: 10;\r\n        display: block;\r\n        right: 0px;\r\n        width: 50px;\r\n        text-align: right;\r\n        top: 0px;\r\n    }\r\n\r\n    h6 {\r\n        font-weight: 500;\r\n    }\r\n\r\n    .price-container {\r\n        line-height: 1;\r\n        margin-top: 4px;\r\n\r\n        .more {\r\n            i {\r\n                font-size: 24px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .opportunities {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .price {\r\n        font-size: 12px;\r\n        display: inline-block;\r\n\r\n        &.popup {\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .company-code {\r\n        float: right;\r\n    }\r\n\r\n    .vehicle-name {\r\n        h6 {\r\n            margin-top: 0;\r\n            font-size: 15px;\r\n        }\r\n    }\r\n\r\n    .vehicle-specs {\r\n        line-height: 0px;\r\n\r\n        app-attribute-list {\r\n            line-height: 10px;\r\n            // min-height: 29px;\r\n            color: var(--ion-color-medium);\r\n            font-size: 10px;\r\n        }\r\n    }\r\n\r\n    .status-indicator {\r\n        top: 0;\r\n        margin-right: 4px;\r\n    }\r\n\r\n    .inactive-vehicle {\r\n        opacity: 0.5;\r\n        // text-decoration: line-through !important;\r\n    }\r\n}\r\n\r\n/* min-width 640px, medium screens */\r\n@media only screen and (min-width: 640px) {\r\n    .vehicle-result {\r\n        // max-width: 760px;\r\n        margin: auto;\r\n    }\r\n\r\n    h6 {\r\n        width: 80%;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 359px) {\r\n    app-image-displayer {\r\n        width: 50px;\r\n        height: 50px;\r\n    }\r\n}\r\n\r\n.status-indicator {\r\n    top: 0;\r\n    margin-right: 4px;\r\n}\r\n\r\n.inactive-vehicle {\r\n    opacity: 0.5;\r\n    // text-decoration: line-through !important;\r\n}\r\n\r\n\r\n.vehicle-status.unsold .status-indicator {\r\n    background-color: #ff0000;\r\n}\r\n\r\n.vehicle-status.all .status-indicator {\r\n    background-color: #25aa3b;\r\n}\r\n\r\n.vehicle-status.all .status-indicator {\r\n    background-color: var(--ion-color-primary);\r\n}\r\n\r\n.vehicle-status.inactive .status-indicator {\r\n    background-color: #ccc;\r\n}\r\n\r\n.vehicle-status.sold .status-indicator {\r\n    background-color: #ff66ff;\r\n}\r\n\r\n.vehicle-status.onyard .status-indicator {\r\n    background-color: #0c0;\r\n}\r\n\r\n.vehicle-status.atsupplier .status-indicator {\r\n    background-color: #f90;\r\n}\r\n\r\n.vehicle-status.atcompliance .status-indicator {\r\n    background-color: #999;\r\n}\r\n\r\n.vehicle-status.intransit .status-indicator {\r\n    background-color: #fc0;\r\n}\r\n\r\n.vehicle-status.ontestdrive .status-indicator {\r\n    background-color: #06f;\r\n}\r\n\r\n.vehicle-status.onloan .status-indicator {\r\n    background-color: #06f;\r\n}\r\n\r\n.vehicle-status.atorigin .status-indicator {\r\n    background-color: #ee6558;\r\n}\r\n\r\n.vehicle-status.atauction .status-indicator {\r\n    background-color: #57bad2;\r\n}\r\n\r\n.vehicle-status.other .status-indicator {\r\n    background-color: #909090;\r\n}\r\n\r\n.status-indicator.small {\r\n    top: 0;\r\n    margin-right: 4px;\r\n}\r\n\r\nion-icon[name=\"checkbox-selected\"],\r\nion-icon[name=\"checkbox-unselected\"],\r\nion-icon[name=\"checkbox-indeterminate\"] {\r\n    font-size: 24px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
